import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { shareReplay } from 'rxjs/operators';
import { InsightsRestService } from '../../../../../../core/service/insights-rest-service';

export interface SalesVolumeRangeResponse {
  minVolumeTotal: number;
  maxVolumeTotal: number;
  minSalesSqftByTotalArea: number;
  maxSalesSqftByTotalArea: number;
  minSalesSqftBySalesArea: number;
  maxSalesSqftBySalesArea: number;
}

@Injectable({
  providedIn: 'root'
})
export class SalesVolumeRangeApiService extends InsightsRestService {

  private cache$: Observable<SalesVolumeRangeResponse> | null = null;

  constructor(private http: HttpClient) {
    super();
  }

  getSalesVolumeRange(): Observable<SalesVolumeRangeResponse> {
    if (!this.cache$) {
      const url = this.buildUrl('/rank-by-store/sales-volume-range');
      this.cache$ = this.http.get<SalesVolumeRangeResponse>(url).pipe(
        shareReplay(1)
      );
    }
    return this.cache$;
  }
}
